import Vue from 'vue'
import Router from 'vue-router'
import Store from '../store'

import routerRed from '@/components/routerRed';//启动页
import CConfigSetting from '@/components/CConfigSetting';//配置设置页

//工具柜项目
import CLogin from '@/components/CToolCabinet/CLogin';//登录页
import CBorrow from '@/components/CToolCabinet/page/CEmployee/CBorrow/CBorrow';//借用
import CSearchList from '@/components/CToolCabinet/page/CEmployee/CBorrow/CSearchList';//搜索列表
import COpenDoor from '@/components/CToolCabinet/page/CEmployee/CBorrow/COpenDoor';//借用-打开箱门
import CInventory from '@/components/CToolCabinet/page/CEmployee/CBorrow/CInventory';//借用盘点中
import CCloseDoor from '@/components/CToolCabinet/page/CEmployee/CBorrow/CCloseDoor';//借用-关闭箱门
import CGOpenBorrow from '@/components/CToolCabinet/page/CEmployee/CGiveBack/CGOpenBorrow';//归还-打开箱门
import CGInventory from '@/components/CToolCabinet/page/CEmployee/CGiveBack/CGInventory';//归还-盘点中
import CAdminIndex from '@/components/CToolCabinet/page/CAdmin/CAdminIndex';//管理员
import CAOpenDoor from '@/components/CToolCabinet/page/CAdmin/CAOpenDoor';//管理员-打开箱门
import CAInventory from '@/components/CToolCabinet/page/CAdmin/CAInventory';//管理员盘点中
import CABiosignAture from '@/components/CToolCabinet/page/CAdmin/CABiosignAture';//管理员-录入员工生物特征

import reView from '@/components/CToolCabinet/page/reView/reView';//复核清单

//无人仓项目
import wrcIndex from '@/components/CUnmanned/wrcIndex';//出入库首页
import wrcLogin from '@/components/CUnmanned/wrcLogin';//出入库登录验证
import wrcOutStockList from '@/components/CUnmanned/wrcOutStock/wrcOutStockList';//出库列表
import wrcInStockList from '@/components/CUnmanned/wrcInStock/wrcInStockList';//入库列表
import CExhibition from '@/components/CUnmanned/CExhibition';//展示屏

/** 周转柜 */
import selectCheck from '@/components/turnoverCabinet/selectCheck'
//公共页面
import saveSelectWay from '@/components/turnoverCabinet/common/saveSelectWay'
import selectCell from '@/components/turnoverCabinet/common/selectCell'
import saveFinish from '@/components/turnoverCabinet/common/saveFinish'
// 用户存
import selectConsignee from '@/components/turnoverCabinet/userSave/selectConsignee'
// 快递存
import importPhone from '@/components/turnoverCabinet/expressSave/importPhone'
import scanExpressCode from '@/components/turnoverCabinet/expressSave/scanExpressCode'
// 用户取
import fetchSelectWay from '@/components/turnoverCabinet/userFetch/fetchSelectWay'
import openBoxOne from '@/components/turnoverCabinet/userFetch/openBoxOne'
import openBoxList from '@/components/turnoverCabinet/userFetch/openBoxList'

// 取件二维码
import pickupQRcode from '@/components/turnoverCabinet/pickupQRcode'

/** E站旧 */
import eSiteIndex from '@/components/CEsite/eSiteIndex'
// E站入库
import enWarehouse from '@/components/CEsite/EN-warehouse'
import enWarehouseScan from '@/components/CEsite/EN-warehouse/enWarehouseScan'
import enWarehouseFinal from '@/components/CEsite/EN-warehouse/enWarehouseFinal'
import enWarehouseList from '@/components/CEsite/EN-warehouse/enWarehouseList'
import enWarehouseLog from '@/components/CEsite/EN-warehouse/enWarehouseLog'
// E站出库
import exWarehouse from '@/components/CEsite/EX-warehouse'

/** 寄存柜 */
import locker from '@/components/locker/locker'

/** 办公寄存柜 */
import officeLocker from '@/components/officeLocker/officeLocker'
import officeLockerLogin from '@/components/officeLocker/page/login'
import officeLockerSelectCell from '@/components/officeLocker/page/selectCell'
import officeLockerOpenBox from '@/components/officeLocker/page/openBox'


/** 信报箱 */
import mailBox from '@/components/mailBox/mailBox'

/** 钥匙柜 */
import keyCabinet from '@/components/keyCabinet/keyLogin'
import keyBorrow from '@/components/keyCabinet/keyBorrow/keyBorrow'
import keyOpenDoor from '@/components/keyCabinet/keyBorrow/keyOpenDoor'
import keyGiveOpen from '@/components/keyCabinet/keyGiveBack/keyGiveOpen'

// 公共页面
import mailBoxSelectWay from '@/components/mailBox/common/selectWay'
import mailBoxSaveFinish from '@/components/mailBox/common/saveFinish'
// 用户存
import mailBoxUserSaveFlow from '@/components/mailBox/userSave/userSaveFlow'
import mailBoxSelectConsignee from '@/components/mailBox/userSave/selectConsignee'
import mailBoxScanExpressCode from '@/components/mailBox/userSave/scanExpressCode'
// 快速存件
import mailBoxUserFastSaveFlow from '@/components/mailBox/userFastSave/userFastSaveFlow'
// 用户取
import mailBoxUserFetchFlow from '@/components/mailBox/userFetch/userFetchFlow'
import mailBoxFetchSelectWay from '@/components/mailBox/userFetch/selectWay'
import mailBoxOpenBoxOne from '@/components/mailBox/userFetch/openBoxOne'
// 取件二维码
import mailBoxPickupQRcode from '@/components/mailBox/pickupQRcode'

/* 会议室预约管理系统 */
import MRMS from '@/components/MRMS/MRMS'

/* 图书柜 */
import Bookcase from '@/components/Bookcase/Bookcase'
import BookcaseIndex from '@/components/Bookcase/Common/Index'         // 首页/扫码登录
import BookcaseMArea from '@/components/Bookcase/Common/MainArea'
import BookcaseRegister from '@/components/Bookcase/Common/Register'    // 扫码注册
import BookcaseAirlines from '@/components/Bookcase/Common/Airlines'     // 客服
import BookcaseMyReserve from '@/components/Bookcase/Buy/MyReserve'     // 买书——我的预定
import BookcaseGsList from '@/components/Bookcase/Buy/GoodsList'        // 买书——浏览商品（商品列表）
import BookcaseGsDetail from '@/components/Bookcase/Buy/GoodsDetail'    // 买书——商品详情
import BookcasePaylist from '@/components/Bookcase/Buy/Paylist'     // 买书——扫描条码、支付列表
import BookcasePay from '@/components/Bookcase/Buy/Pay'                 // 买书——支付
import BookcaseMySell from '@/components/Bookcase/Sell/MySell'          // 卖书——我的售卖
import BookcaseSScanCode from '@/components/Bookcase/Sell/SScanCode'    // 卖书——扫描条码
import BookcaseSOpenBox from '@/components/Bookcase/Sell/SOpenBox'    // 卖书——开箱
import BookcaseSCloseBox from '@/components/Bookcase/Sell/SCloseBox'    // 卖书——关箱

/* E站 */
import QRCode from '@/assets/QRCode';//二维码
import CEsite40s from '@/components/CEsite40s/index/index';//首页
import ELogin from '@/components/CEsite40s/login/login';//登录
import ESelectBox from '@/components/CEsite40s/SelectBox/SelectBox';//选择箱格
import EScanCode from '@/components/CEsite40s/ScanCode/ScanCode';//扫码入库
import EWarehousList from '@/components/CEsite40s/WarehousList/WarehousList';//预约入库清单
import EStoRecords from '@/components/CEsite40s/StoRecords/StoRecords';//入库清单
import EOutStock from '@/components/CEsite40s/OutStock/OutStock';//出库
import EOutDoor from '@/components/CEsite40s/OutDoor/OutDoor';//出库结果

/* 生鲜柜 */
import FreshCabinet from '@/components/FreshCabinet/index/index';//首页
import FLogin from '@/components/FreshCabinet/login/login';//登录
import FDeliveryType from '@/components/FreshCabinet/deliveryType/deliveryType';//寄件方式
import FSelectBox from '@/components/FreshCabinet/SelectBox/SelectBox';//选择箱格
import FScanCode from '@/components/FreshCabinet/ScanCode/ScanCode';//扫码入库
import FWarehousList from '@/components/FreshCabinet/WarehousList/WarehousList';//已派快递清单
import FStoRecords from '@/components/FreshCabinet/StoRecords/StoRecords';//管理预约箱格
import FOutStock from '@/components/FreshCabinet/OutStock/OutStock';//取件
import FOutDoor from '@/components/FreshCabinet/OutDoor/OutDoor';//取件结果

const bcWidth = 1080

Vue.use(Router)

const router =  new Router({
  routes: [
    /* 生鲜柜 */
    {
      path: '/QRCode',
      name: 'QRCode',
      component: QRCode,
      meta: {
        title: '二维码'
      }
    },{
      path: '/FreshCabinet',
      name: 'FreshCabinet',
      component: FreshCabinet,
      meta: {
        title: '首页'
      }
    },{
      path: '/FreshCabinet/FLogin',
      name: 'FLogin',
      component: FLogin,
      meta: {
        title: '快递员登录'
      }
    },{
      path: '/FreshCabinet/FDeliveryType',
      name: 'FDeliveryType',
      component: FDeliveryType,
      meta: {
        title: '寄件方式'
      }
    },{
      path: '/FreshCabinet/FSelectBox',
      name: 'FSelectBox',
      component: FSelectBox,
      meta: {
        title: '选择箱格'
      }
    },{
      path: '/FreshCabinet/FScanCode',
      name: 'FScanCode',
      component: FScanCode,
      meta: {
        title: '扫码入库'
      },
    },{
      path: '/FreshCabinet/FWarehousList',
      name: 'FWarehousList',
      component: FWarehousList,
      meta: {
        title: '已派快递清单'
      },
    },{
      path: '/FreshCabinet/FStoRecords',
      name: 'FStoRecords',
      component: FStoRecords,
      meta: {
        title: '管理预约箱格'
      },
    },{
      path: '/FreshCabinet/FOutStock',
      name: 'FOutStock',
      component: FOutStock,
      meta: {
        title: '出库'
      },
    },{
      path: '/FreshCabinet/FOutDoor',
      name: 'FOutDoor',
      component: FOutDoor,
      meta: {
        title: '取件结果'
      },
    },
    /* E站 */
    {
      path: '/CEsite40s',
      name: 'CEsite40s',
      component: CEsite40s,
      meta: {
        title: '首页'
      }
    },{
      path: '/CEsite40s/ELogin',
      name: 'ELogin',
      component: ELogin,
      meta: {
        title: '快递员登录'
      },
    },{
      path: '/CEsite40s/ESelectBox',
      name: 'ESelectBox',
      component: ESelectBox,
      meta: {
        title: '选择箱格'
      },
    },{
      path: '/CEsite40s/EScanCode',
      name: 'EScanCode',
      component: EScanCode,
      meta: {
        title: '扫码入库'
      },
    },{
      path: '/CEsite40s/EWarehousList',
      name: 'EWarehousList',
      component: EWarehousList,
      meta: {
        title: '预约入库清单'
      },
    },{
      path: '/CEsite40s/EStoRecords',
      name: 'EStoRecords',
      component: EStoRecords,
      meta: {
        title: '入库清单'
      },
    },{
      path: '/CEsite40s/EOutStock',
      name: 'EOutStock',
      component: EOutStock,
      meta: {
        title: '出库'
      },
    },{
      path: '/CEsite40s/EOutDoor',
      name: 'EOutDoor',
      component: EOutDoor,
      meta: {
        title: '出库结果'
      },
    },
    
    /* 图书柜 */
    {
      path: '/Bookcase',
      name: 'Bookcase',
      component: Bookcase,
      meta: {
        title: '图书柜',
        width: bcWidth
      },
      children: [
        // 图书柜-首页
        {
          path: 'Index',
          name: 'BookcaseIndex',
          component: BookcaseIndex,
          meta: {
            title: '首页',
            width: bcWidth,
            notNoOp: true, // 不引入倒计时
            showIdleAds: true, // 显示闲置广告
          },
        },
        // 图书柜-登录
        {
          path: 'Login',
          name: 'BookcaseLogin',
          component: BookcaseIndex,
          meta: {
            title: '登录',
            width: bcWidth
          },
        },
        // 带导航栏页面
        {
          path: '',
          name: 'BookcaseMArea',
          component: BookcaseMArea,
          meta: {
            title: '主内容',
            width: bcWidth
          },
          children: [
            // 图书柜-注册
            {
              path: 'Register',
              name: 'BookcaseRegister',
              component: BookcaseRegister,
              meta: {
                title: '扫码注册',
                hideLogout: true,
                width: bcWidth
              },
            },
            // 图书柜-客服
            {
              path: 'Airlines',
              name: 'BookcaseAirlines',
              component: BookcaseAirlines,
              meta: {
                title: '客服',
                hideLogout: true,
                width: bcWidth
              },
            },
            // 图书柜-买书-我的预定
            {
              path: 'MyReserve',
              name: 'BookcaseMyReserve',
              component: BookcaseMyReserve,
              meta: {
                title: '我的预定',
                hideBack: true,
                width: bcWidth
              },
            },
            // 图书柜-买书-浏览商品（商品列表）
            {
              path: 'GoodsList',
              name: 'BookcaseGsList',
              component: BookcaseGsList,
              meta: {
                title: '更多',
                width: bcWidth
              },
            },
            // 图书柜-买书-商品详情
            {
              path: 'GoodsDetail',
              name: 'BookcaseGsDetail',
              component: BookcaseGsDetail,
              meta: {
                title: '详情',
                width: bcWidth
              },
            },
            // 图书柜-买书-扫描条码
            {
              path: 'BScanCode',
              name: 'BookcaseBScanCode',
              component: BookcasePaylist,
              meta: {
                title: '支付',
                width: bcWidth
              },
            },
            // 图书柜-买书-支付（支付列表）
            {
              path: 'PayList',
              name: 'BookcasePayList',
              component: BookcasePaylist,
              meta: {
                title: '支付',
                width: bcWidth
              },
            },
            // 图书柜-买书-支付
            {
              path: 'Pay',
              name: 'BookcasePay',
              component: BookcasePay,
              meta: {
                title: '支付',
                hideBack: true,
                width: bcWidth
              },
            },
            {
              path: 'Pay/:order_id/:total_fee',
              name: 'BookcasePay',
              component: BookcasePay,
              meta: {
                title: '支付',
                hideBack: true,
                width: bcWidth,
                notNoOp: true
              },
            },
            // 图书柜-卖书-我的售卖
            {
              path: 'MySell',
              name: 'BookcaseMySell',
              component: BookcaseMySell,
              meta: {
                title: '我的售卖',
                hideBack: true,
                width: bcWidth
              },
            },
            // 图书柜-卖书-扫描条码
            {
              path: 'SScanCode',
              name: 'BookcaseSScanCode',
              component: BookcaseSScanCode,
              meta: {
                title: '扫描条码',
                width: bcWidth
              },
            },
            // 图书柜-卖书-开箱
            {
              path: 'SOpenBox',
              name: 'BookcaseSOpenBox',
              component: BookcaseSOpenBox,
              meta: {
                title: '开箱',
                width: bcWidth
              },
            },
            // 图书柜-卖书-关箱
            {
              path: 'SCloseBox',
              name: 'BookcaseSCloseBox',
              component: BookcaseSCloseBox,
              meta: {
                title: '关箱',
                width: bcWidth
              },
            },
          ]
        },


        // // 图书柜-客服
        // {
        //   path: 'Airlines',
        //   name: 'BookcaseAirlines',
        //   component: BookcaseMArea,
        //   meta: {
        //     title: '客服',
        //     hideLogout: true
        //   },
        // },
        // // 图书柜-买书-我的预定
        // {
        //   path: 'MyReserve',
        //   name: 'BookcaseMyReserve',
        //   component: BookcaseMArea,
        //   meta: {
        //     title: '我的预定'
        //   },
        // },
        // // 图书柜-买书-浏览商品（商品列表）
        // {
        //   path: 'GoodsList',
        //   name: 'BookcaseGsList',
        //   component: BookcaseMArea,
        //   meta: {
        //     title: '更多'
        //   },
        // },
        // // 图书柜-买书-商品详情
        // {
        //   path: 'GoodsDetail',
        //   name: 'BookcaseGsDetail',
        //   component: BookcaseMArea,
        //   meta: {
        //     title: '详情'
        //   },
        // },

      ]
    },
    {
      path: '/',
      redirect:'/routerRed'
    },
    {
      path: '/routerRed',
      name: 'routerRed',
      component: routerRed,
      meta: {
        title: '极酷智控'
      }
    },
    {
      path: '/CConfigSetting',
      name: 'CConfigSetting',
      component: CConfigSetting,
      meta: {
        title: '项目配置'
      }
    },
    {
      path: '/toolCabinet/CLogin',
      name: 'CLogin',
      component: CLogin,
      meta: {
        title: '工具柜-登录'
      }
    },
    
    //借用
    {
      path: '/toolCabinet/CBorrow',
      name: 'CBorrow',
      component: CBorrow,
      meta: {
        auth: true,
        title: '工具柜-箱格列表'
      }
    },
    //搜索列表
    {
      path: '/toolCabinet/CSearchList',
      name: 'CSearchList',
      component: CSearchList,
      meta: {
        auth: true,
        title: '工具柜-箱格列表'
      }
    },
    //借用-打开箱门
    {
      path: '/toolCabinet/CBorrow/COpenDoor',
      name: 'COpenDoor',
      component: COpenDoor,
      meta: {
        auth: true,
        title: '工具柜-借用-打开箱门'
      }
    },
    //借用盘点中
    {
      path: '/toolCabinet/CBorrow/CInventory',
      name: 'CInventory',
      component: CInventory,
      meta: {
        auth: true,
        title: '工具柜-借用-盘点'
      }
    },
    //借用-关闭箱门
    {
      path: '/toolCabinet/CCloseDoor',
      name: 'CCloseDoor',
      component: CCloseDoor,
      meta:{
        title:'工具柜-盘点结果'
      }
    },
    
    //归还-打开箱门
    {
      path: '/toolCabinet/CGiveBack/CGOpenBorrow',
      name: 'CGOpenBorrow',
      component: CGOpenBorrow,
      meta:{
        title:'工具柜-归还-打开箱门'
      }
    },
    //归还-盘点中
    {
      path: '/toolCabinet/CGiveBack/CGInventory',
      name: 'CGInventory',
      component: CGInventory,
      meta:{
        title:'工具柜-归还-盘点'
      }
    },

    //管理员
    {
      path: '/toolCabinet/CAdmin',
      name: 'CAdminIndex',
      component: CAdminIndex,
      meta: {
        auth: true,
        title: '工具柜-管理员'
      }
    },
    //管理员-打开箱门
    {
      path: '/toolCabinet/CAdmin/CAOpenDoor',
      name: 'CAOpenDoor',
      component: CAOpenDoor,
      meta: {
        auth: true,
        title: '工具柜-管理员-打开箱门'
      }
    },
    //管理员-盘点中
    {
      path: '/toolCabinet/CAdmin/CAInventory',
      name: 'CAInventory',
      component: CAInventory,
      meta: {
        auth: true,
        title: '工具柜-管理员-盘点'
      }
    },
    //管理员-录入员工生物特征
    {
      path: '/toolCabinet/CAdmin/CABiosignAture',
      name: 'CABiosignAture',
      component: CABiosignAture,
      meta: {
        auth: true,
        title: '工具柜-管理员-员工管理'
      }
    },

    //复核清单
    {
      path: '/toolCabinet/reView',
      name: 'reView',
      component: reView,
      meta: {
        title: '工具柜-复核清单'
      }
    },

    //医疗柜首页
    {
      path: '/unmanned/wrcIndex',
      name: 'wrcIndex',
      component: wrcIndex,
      meta: {
        title: '医疗柜',
      }
    },
    {
      path: '/unmanned/wrcLogin',
      name: 'wrcLogin',
      component: wrcLogin,
      meta: {
        title: '医疗柜-登录'
      }
    },{
      path: '/unmanned/wrcOutStockList',
      name: 'wrcOutStockList',
      component: wrcOutStockList,
      meta: {
        title: '医疗柜-出库'
      }
    },{
      path: '/unmanned/wrcInStockList',
      name: 'wrcInStockList',
      component: wrcInStockList,
      meta: {
        title: '医疗柜-入库'
      }
    },{
      path: '/unmanned/CExhibition',
      name: 'CExhibition',
      component: CExhibition,
      meta: {
        title: '医疗柜-展示屏'
      }
    },

    /**周转柜*/
    {
      path: '/turnoverCabinet',
      name: 'selectCheck',
      component: selectCheck,
      meta: {
        title: '周转柜'
      }
    },
    /** 公共页面 */
    // 存件选择身份认证方法
    {
      path: '/turnoverCabinet/saveSelectWay',
      name: 'saveSelectWay',
      component: saveSelectWay,
      meta: {
        title: '周转柜-存件选择身份认证方法'
      }
    },
    // 选择箱格大小
    {
      path: '/turnoverCabinet/selectCell',
      name: 'selectCell',
      component: selectCell,
      meta: {
        title: '周转柜-选择箱格大小'
      }
    },
    // 存件完成
    {
      path: '/turnoverCabinet/saveFinish',
      name: 'saveFinish',
      component: saveFinish,
      meta: {
        title: '周转柜-存件完成'
      }
    },
    /** 用户存 */
    // 选择取件人
    {
      path: '/turnoverCabinet/selectConsignee',
      name: 'selectConsignee',
      component: selectConsignee,
      meta: {
        title: '周转柜-选择取件人'
      }
    },
    // 取件二维码
    {
      path: '/turnoverCabinet/pickupQRcode',
      name: 'pickupQRcode',
      component: pickupQRcode,
      meta: {
        title: '周转柜-取件二维码'
      }
    },

    /** 快递存 */
    // 输入取件人手机号
    {
      path: '/turnoverCabinet/importPhone',
      name: 'importPhone',
      component: importPhone,
      meta: {
        title: '周转柜-输入取件人手机号'
      }
    },
    // 扫描快递单号
    {
      path: '/turnoverCabinet/scanExpressCode',
      name: 'scanExpressCode',
      component: scanExpressCode,
      meta: {
        title: '周转柜-扫描快递单号'
      }
    },
    /** 用户取 */
    // 选择身份认证方法
    {
      path: '/turnoverCabinet/fetchSelectWay',
      name: 'fetchSelectWay',
      component: fetchSelectWay,
      meta: {
        title: '周转柜-选择身份认证方法'
      }
    },
    // 单个箱格取件
    {
      path: '/turnoverCabinet/openBoxOne',
      name: 'openBoxOne',
      component: openBoxOne,
      meta: {
        title: '周转柜-单个箱格取件'
      }
    },
    // 多个箱格取件
    {
      path: '/turnoverCabinet/openBoxList',
      name: 'openBoxList',
      component: openBoxList,
      meta: {
        title: '周转柜-多个箱格取件'
      }
    },

    /** E站旧 */
    {
      path: '/eSite',
      name: 'eSiteIndex',
      component: eSiteIndex,
      meta: {
        title: 'E站'
      }
    },
    {
      path: '/eSite/enWarehouse',
      name: 'enWarehouse',
      component: enWarehouse,
      meta: {
        title: '入库'
      }
    },
    {
      path: '/eSite/enWarehouse/enWarehouseScan',
      name: 'enWarehouseScan',
      component: enWarehouseScan,
      meta: {
        title: '扫码'
      }
    },
    {
      path: '/eSite/enWarehouse/enWarehouseFinal',
      name: 'enWarehouseFinal',
      component: enWarehouseFinal,
      meta: {
        title: '箱门关闭'
      }
    },
    {
      path: '/eSite/enWarehouse/enWarehouseList',
      name: 'enWarehouseList',
      component: enWarehouseList,
      meta: {
        title: '入库清单'
      }
    },
    {
      path: '/eSite/enWarehouse/enWarehouseLog',
      name: 'enWarehouseLog',
      component: enWarehouseLog,
      meta: {
        title: '入库记录'
      }
    },
    {
      path: '/eSite/exWarehouse',
      name: 'exWarehouse',
      component: exWarehouse,
      meta: {
        title: '出库'
      }
    },

    /** 寄存柜 */
    {
      path: '/locker',
      name: 'locker',
      component: locker,
      meta: {
        title: '寄存柜'
      }
    },

    /** 办公寄存柜 */
    {
      path: '/officeLocker',
      name: 'officeLocker',
      component: officeLocker,
      meta: {
        title: '办公寄存柜'
      }
    },
    {
      path: '/officeLocker/login',
      name: 'officeLockerLogin',
      component: officeLockerLogin,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/officeLocker/selectCell',
      name: 'officeLockerSelectCell',
      component: officeLockerSelectCell,
      meta: {
        title: '选择箱格大小'
      }
    },
    {
      path: '/officeLocker/openBox',
      name: 'officeLockerOpenBox',
      component: officeLockerOpenBox,
      meta: {
        title: '打开箱子'
      }
    },

    

    /** 信报箱 */
    {
      path: '/mailBox',
      name: 'mailBox',
      component: mailBox,
      meta: {
        title: '信报箱'
      }
    },
    // 公共页面
    {
      path: '/mailBox/common/selectWay',
      name: 'mailBoxSelectWay',
      component: mailBoxSelectWay
    },
    {
      path: '/mailBox/common/saveFinish',
      name: 'mailBoxSaveFinish',
      component: mailBoxSaveFinish
    },
    // 一般存件
    {
      path: '/mailBox/userSave/userSaveFlow',
      name: 'mailBoxUserSaveFlow',
      component: mailBoxUserSaveFlow
    },
    // 快速存件
    {
      path: '/mailBox/userFastSave/userFastSaveFlow',
      name: 'mailBoxUserFastSaveFlow',
      component: mailBoxUserFastSaveFlow
    },
    // 选择取件人
    {
      path: '/mailBox/userSave/selectConsignee',
      name: 'mailBoxSelectConsignee',
      component: mailBoxSelectConsignee
    },
    // 扫码
    {
      path: '/mailBox/userSave/scanExpressCode',
      name: 'mailBoxScanExpressCode',
      component: mailBoxScanExpressCode
    },
    // 用户取
    {
      path: '/mailBox/userFetch/userFetchFlow',
      name: 'mailBoxUserFetchFlow',
      component: mailBoxUserFetchFlow
    },
    {
      path: '/mailBox/userFetch/selectWay',
      name: 'mailBoxFetchSelectWay',
      component:  mailBoxFetchSelectWay
    },
    {
      path: '/mailBox/userFetch/openBoxOne',
      name: 'mailBoxOpenBoxOne',
      component:  mailBoxOpenBoxOne
    },
    // 取件二维码
    {
      path: '/mailBox/pickupQRcode',
      name: 'mailBoxPickupQRcode',
      component:  mailBoxPickupQRcode
    },

    /** 钥匙柜 */
    {
      path: '/keyCabinet',
      name: 'keyCabinet',
      component: keyCabinet,
      meta: {
        title: '钥匙柜'
      }
    },
    {
      path: '/keyCabinet/keyBorrow',
      name: 'keyBorrow',
      component: keyBorrow,
      meta: {
        title: '钥匙柜-借用'
      }
    },
    {
      path: '/keyCabinet/keyOpenDoor',
      name: 'keyOpenDoor',
      component: keyOpenDoor,
      meta: {
        title: '钥匙柜-借用'
      }
    },
    {
      path: '/keyCabinet/keyGiveOpen',
      name: 'keyGiveOpen',
      component: keyGiveOpen,
      meta: {
        title: '钥匙柜-归还'
      }
    },

    /* 会议室预约管理系统 */
    {
      path: '/MRMS',
      name: 'MRMS',
      component: MRMS,
      meta: {
        title: '会议室预约管理系统'
      }
    },

  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.meta.width){
    Store.state.scrWidth = to.meta.width
  }
  next()
  // 注册一个全局前置守卫
  if (to.matched.some(m => m.meta.auth)) {
    // 判断是否需要校验
    if (localStorage.getItem("eUserInfo")) {
      // 获取
      next(); // 校验通过，正常跳转到你设置好的页面
    } else {
      next({
        // 校验失败，跳转至登录界面
        path: "/",
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数，用于在登录成功后获取并跳转到该路径
      });
    }
  } else {
    next(); // 不需要校验，直接跳转
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js